'use es6';

import PropTypes from 'prop-types';
export default PropTypes.arrayOf(PropTypes.array);